import { Reveal } from "./Reveal";
import { TIMELINE } from "../../data/smartContent";

export const SmartHistory = () => (
  <section data-testid="section-history" className="bg-white py-14 lg:py-20">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <div className="max-w-3xl">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-isic">Credibilitate</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl font-semibold leading-[1.15] text-ink">
            Istoria legitimației ISIC
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            De la primele legitimații până la varianta actuală, ISIC a însoțit elevii și studenții timp de peste șapte
            decenii.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="mt-10 grid grid-cols-3 gap-4">
          {TIMELINE.map((item) => (
            <div key={item.year} className="relative pt-6">
              <span className="absolute top-0 left-0 h-px w-full bg-slate-200" />
              <span className="absolute -top-[5px] left-0 h-2.5 w-2.5 rounded-full bg-isic" />
              <p className="font-serif text-2xl font-semibold text-ink">{item.year}</p>
              <p className="mt-1 text-sm text-slate-500 leading-snug">{item.label}</p>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-8 rounded-3xl border border-slate-200 bg-slate-50 p-5 lg:p-8">
          <img
            alt="Evoluția legitimației ISIC de-a lungul deceniilor"
            className="mx-auto w-full max-w-3xl h-auto"
            src="/assets/isic-history.png"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
